// extracted by mini-css-extract-plugin
export default {"top-header":"TopHeader_top-header__+KUGA","user-icon":"TopHeader_user-icon__LIYOI"};